import React from 'react';

export default function CopyIcon({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3542 5.125V2.60417C16.3542 2.09791 15.9438 1.6875 15.4375 1.6875H2.60417C2.09791 1.6875 1.6875 2.0979 1.6875 2.60417V15.4375C1.6875 15.9438 2.09791 16.3542 2.60417 16.3542H5.125"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.64453 8.56266C7.64453 8.0564 8.05494 7.646 8.5612 7.646H21.3945C21.9008 7.646 22.3112 8.05641 22.3112 8.56266V21.396C22.3112 21.9023 21.9008 22.3127 21.3945 22.3127H8.5612C8.05493 22.3127 7.64453 21.9023 7.64453 21.396V8.56266Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
